import styled from 'styled-components'

export const TabButtonContainer = styled.div.attrs(({ dataTestId }) => ({
  'data-testid': dataTestId,
}))``
